import { getApi } from 'common/modules/ReactShared/data/api/apiClient';
import { IArticleDetail, IArticleDetailResponse, IArticlesIndexResponse } from './types';

const ARTICLES_PER_PAGE = 10;

export async function getArticles(page = 1): Promise<IArticlesIndexResponse> {
  const { data } = await getApi().get<IArticlesIndexResponse>('/articles', {
    params: { page, per_page: ARTICLES_PER_PAGE }
  });
  return data;
}

export async function getArticle(id: number): Promise<IArticleDetail> {
  const { data } = await getApi().get<IArticleDetailResponse>(`/articles/${id}`);
  return data.article;
}

export async function markArticleRead(id: number): Promise<void> {
  await getApi().post(`/articles/${id}/mark_as_read`);
}
